/* eslint-disable */
import Vue from 'vue'

class RutValidator {
  formatValidator (value: any) {
    if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(value)) {
			return false
    }

		const tmp = value.split('-')
		const rut = tmp[0]
		let digv = tmp[1]

		if (digv === 'K') {
      digv = 'k'
    }

		return (this.validator(rut) == digv)
  }

  validator (T: any) {
		let M = 0, S = 1

		for (; T; T = Math.floor(T/10)) {
			S = (S + T % 10 * (9 - M++ % 6)) % 11
    }

		return S ? S-1 : 'k'
	}
}

Vue.prototype.$rutValidator = new RutValidator()
